import { render } from "./CompetenciaView.vue?vue&type=template&id=10a495b8&scoped=true"
import script from "./CompetenciaView.vue?vue&type=script&lang=js"
export * from "./CompetenciaView.vue?vue&type=script&lang=js"

import "./CompetenciaView.vue?vue&type=style&index=0&id=10a495b8&lang=scss&field=true&scoped=true"

import exportComponent from "/home/ctis-desenvolvimento/Projetos/front-end/piso-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a495b8"]])

export default __exports__